module.exports = __webpack_public_path__ + "img/trash-can-plus.c9f50c76.svg";